import type {
  ICompanyClaims,
  ICustomerClaims,
} from "../zeos-api/contracts/Account";

export const getClaimCompanies = (
  customerClaims?: ICustomerClaims[]
): ICompanyClaims[] =>
  Array.from(
    new Map(
      (customerClaims ?? [])
        .flatMap((customer) => customer.companies ?? [])
        .map((company) => [company.companyId, company])
    ).values()
  );

export const findClaimCompany = (
  customerClaims: ICustomerClaims[] | undefined,
  companyId?: number,
  propertyId?: number
): ICompanyClaims | undefined => {
  const companies = getClaimCompanies(customerClaims);
  if (companyId != null) {
    return companies.find((company) => company.companyId === companyId);
  }

  // No company in the URL - resolve it from the property so links that only
  // carry ?property= don't fall back to an unrelated first company.
  if (propertyId != null) {
    const owner = companies.find((company) =>
      company.properties?.some((property) => property.propertyId === propertyId)
    );
    if (owner) {
      return owner;
    }
  }

  return companies[0];
};

/**
 * Service Layer access rule: the Screening tools are only relevant to customers
 * whose user group manages more than one portfolio (a portfolio is a company
 * claim). Super admins always qualify — they operate across every portfolio.
 */
export const managesMultiplePortfolios = (
  user?: { customerClaims?: ICustomerClaims[]; isSuperAdmin?: boolean } | null
): boolean =>
  !!user?.isSuperAdmin || getClaimCompanies(user?.customerClaims).length > 1;
